import { LeftColumnFacets } from '../../../../../../components/Blocks/Search/LeftColumnFacets';

export default LeftColumnFacets;
